<template>
    <!--审核表单-->
    <div>
        <el-dialog title="审批" :visible.sync="dialogVisibleBusiness"
                   :before-close="cancelBusiness">
            <el-form>
                <el-form-item label="审核状态" prop="status" >
                    <el-radio v-model="checkForm.status" :label=1>通过</el-radio>
                    <el-radio v-model="checkForm.status" :label=0>不通过</el-radio>
                </el-form-item>
                <!--只有审核不通过且审批类型不是关闭订单的情况才需要填写不通过原因-->
                <el-form-item v-if="checkForm.status == 0 && check_type != 2" label="不通过原因">
                    <el-select v-model="checkForm.reason">
                        <el-option  label="请选择" value=""></el-option>
                        <el-option
                                v-for="(reason, key) in reasons"
                                :key="key"
                                :label="reason"
                                :value="key"
                        >
                        </el-option>
                        <el-option  label="其他" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核意见">
                    <el-input type="textarea" :rows="3" placeholder=""
                              v-model="checkForm.memo"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelBusiness">取 消</el-button>
                <el-button type="primary" @click="checkBusiness">确 定</el-button>
            </div>
        </el-dialog>
        <el-row>
            <el-col :span="16">
                <span style="color: red">{{tips_check}}</span>
                <el-steps :space="200" :active="check_progress" finish-status="success">
                    <slot v-if="progresses && progresses.length>0" v-for="value in progresses">
                        <el-step :title="value.executor_memo">
                            <template slot="description" v-if="value.status == 1">
                                <div>{{value['updated_at']}}</div>
                                <div v-if="value['log']">审核意见：{{value['log']['memo']}}</div>
                            </template>
                            <template  v-else-if="value.status == 0">
                                <span slot="icon" class="el-icon-close" style="color: red"></span>
                                <span slot="title" style="color: red">{{value.executor_memo}}</span>
                                <span slot="description" style="color: red">
                                    <div>审核不通过</div>
                                    <div>{{value['updated_at']}}</div>
                                    <div>审核意见：{{value['log']['memo']}}</div>
                                </span>

                            </template>
                            <template slot="description" v-else-if="value.status == 2">
                                待审核
                            </template>
                            <template slot="description" v-else-if="value.status == 3">
                                待审核
                            </template>
                        </el-step>
                        <el-step v-if="value.is_last" title="完成"></el-step>
                    </slot>
                </el-steps>
                <span style="text-align: center" v-if="progresses && progresses.length>0 && progresses[0]['flow']['copy_user']">抄送人：{{_.head(progresses)['flow']['copy_user']}}</span>
            </el-col>
            <el-col :span="8" class="dj-btn-side">
                <el-button v-if="canCheck(tab)" type="primary" style="margin-left: 100px;" :hidden="hidden_undo" size="small" @click="dialogVisibleBusiness = true">审核</el-button>
                <el-button v-if="(canEdit(tab) || is_show_edit) && !order.order_sensitive_masked" @click="edit(tab)" type="primary" style="margin-left: 100px;" size="small">编辑</el-button>
                <el-button v-if="canRevise(tab) && Acs('/order/revise') && !$route.query['flow_type'] && type !=1 && !order.order_sensitive_masked" @click="revise(tab)"  type="primary" style="margin-left: 100px;" size="small">修订</el-button>
                <el-tooltip class="item" effect="light" content="退单或者销售金额下调的订单请选择退单/减额修订" placement="top">
                    <el-button v-if="canRevise(tab) && Acs('/order/refund') && !$route.query['flow_type'] && type !=1 && !order.order_sensitive_masked" @click="refund(tab)"  type="primary" style="margin-left: 100px;" size="small">退款/减额修订</el-button>
                </el-tooltip>
                <el-button v-show="canUndo(tab) "  v-if="type !=1" @click="undo(tab)" :hidden="hidden_undo" type="primary" style="margin-left: 100px;" size="small">撤销
                </el-button>
            </el-col>
        </el-row>
    </div>

</template>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import OrderService from "~/services/order";
    import ApproveService from "~/services/approve";
    import Params from "~/config/params";

    let cache = {};
    export default {
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            tab: {
                required: true
            },
            type: {
                required: true
            }
        },
        computed:{

        },
        watch: {
            tab(newvalue, oldvalue){

            },
            order(newvalue, oldvalue){
                if(this.order.user && this.order.user.length>0){
                    this.is_mine = this.order.user.find(item=>{
                        return item.is_cooperator == 0 && item.user_id == this.$store.getters.userId;
                    })
                }
            },
            "checkForm.type": function(value, oldValue) {
                this.getReasons(value);
            }
        },
        created() {
            this.getReasons(this.tab);
        },
        data() {
            return {
                tips_check:'',
                is_show_edit:false,
                hidden_undo:false,
                is_mine:false,//是不是当前用户订单
                is_mine_check: false,//是否到我进行产品审核
                dialogVisibleBusiness: false,
                is_checked: false,//是否审核过
                progresses: [], //流程进度
                check_progress: 0,//当前流程进度
                checkForm: {//审核表单
                    order_id: 0,//订单id
                    type: 1, //审核表单 1产品2财务3合同
                    status: 1,//审核状态 1通过2为通过
                    memo: '',//审核原因
                    reason: '', // 审批不通过原因
                    edit_time: '', // 流程编辑时间
                },
                reasons: {} // 审批不通过原因枚举序列
            }
        },
        beforeMount() {
            // this.$nextTick(function () {

            // });
            this.getPro();
        },
        methods: {
            to_approve(){
                let path = this.$route.query['referer']?this.$route.query['referer']:"/order/approve";
                this.$router.push({
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                });
            },
            /**主管审批 */
            checkBusiness() {
                this.checkForm.type = this.check_type;
                this.checkForm.order_id = this.id;
                this.checkForm.flow_type = this.tab;
                this.checkForm.revise_id = this.$route.query['revise_id']?this.$route.query['revise_id']:0;
                // 检查并确保编辑时间字段被传递
                if (!this.checkForm.edit_time && this.progresses && this.progresses.length > 0) {
                    // 查找当前用户待审核的流程节点
                    const currentProgress = this.progresses.find(item => 
                        item.flow_node_executor_id == this.$store.getters.userId && 
                        item.status == this.params.TYPE_NO_CHECKED
                    );
                    if (currentProgress) {
                        this.checkForm.edit_time = currentProgress.updated_at || '';
                    }
                }
                
                const loading = this.$loading({
                    lock: true,
                    text: '审核中....'
                })
                ApproveService.approve(this.checkForm).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.to_approve();
                        this.dialogVisibleBusiness = false;
                        this.getPro(this.id);
                        this.getOrder(this.id);
                    }
                    loading.close();
                }).catch(err => {
                    console.error(err)
                    loading.close();
                })
            },
            /**关闭业务审核弹窗*/
            cancelBusiness() {
                this.dialogVisibleBusiness = false;
            },
            revise(type) {//修订操作
                let type_name = ';'
                if (type == this.params.PRODUCT_LINE)  type_name = 'product';
                if (type == this.params.FINANCE_LINE)  type_name = 'finance';
                if (type == this.params.CONTRACT_LINE) type_name = 'contract';
                this.$router.push({
                    path: "/order/revise?id=" + this.id + "&type=" + type_name,
                    query: {
                        referer: this.$route.path
                    }
                });
            },

            refund(type) {//修订退款操作
                let type_name = ';'
                if (type == this.params.PRODUCT_LINE)  type_name = 'product';
                if (type == this.params.FINANCE_LINE)  type_name = 'finance';
                if (type == this.params.CONTRACT_LINE) type_name = 'contract';
                this.$router.push({
                    path: "/order/revise?id=" + this.id + "&type=" + type_name,
                    query: {
                        id: this.id, 
                        type: type_name, 
                        revise_type: 'refund', 
                        referer: this.$route.path, 
                    }
                });
            },
            edit(type) {//编辑操作
                let revise = this.$route.query['type'] == this.params.TYPE_REVISE?true:false;
                let path = '';
                if (type == this.params.PRODUCT_LINE){
                    path = "/order/edit?id=" + this.id + "&type=product";
                    if(revise){
                        path = "/order/revise?id=" + this.id + "&type=product";
                    }
                }
                if (type == this.params.FINANCE_LINE){
                    path = "/order/edit?id=" + this.id + "&type=finance";
                    if(revise){
                        path = "/order/revise?id=" + this.id + "&type=finance";
                    }
                }
                if (type == this.params.CONTRACT_LINE){
                    path = "/order/edit?id=" + this.id + "&type=contract";
                    if(revise){
                        path = "/order/revise?id=" + this.id + "&type=contract";
                    }
                }
                this.$router.push({
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                });
            },
            //是否可以进行修订操作
            canRevise(type){
                if (this.order.close_audit) return false;
                if(!this.Acs('/order/revise')) return false;
                if (type == this.params.PRODUCT_LINE) return this.order.business_audit == this.params.TYPE_CHECKED && !this.order.revise_product ;
                if (type == this.params.FINANCE_LINE){
                    if(this.order.finance_audit == this.params.TYPE_CHECKED_FAIL && (this.order.revise_finance==3 || this.order.revise_finance==2)){
                        return true;
                    }
                    return this.order.finance_audit == this.params.TYPE_CHECKED && !this.order.revise_finance;
                }
                if (type == this.params.CONTRACT_LINE){
                    if(this.order.contract_audit == this.params.TYPE_CHECKED_FAIL && this.order.revise_contract==3){
                        return true;
                    }
                    return this.order.contract_audit == this.params.TYPE_CHECKED && !this.order.revise_contract ;
                }
            },
            undo(type) {//撤销操作
                // 针对补充发票类型的订单使用不同的确认框文本
                let confirmButtonText = '确定';
                let isFillInvoice = this.$route.query['type'] == this.params.FILL_INVOICE;
                if(isFillInvoice) {
                    confirmButtonText = '撤销并编辑';
                }
                
                this.$confirm('此操作将撤销当前正在进行的审核, 是否继续?', '温馨提示', {
                    confirmButtonText: confirmButtonText,
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 如果是补充发票类型，点击撤销编辑按钮直接打开发票弹窗
                    if(isFillInvoice) {
                        // 传递参数，表示强制选中申请开票且不可取消
                        this.$emit('openInvoiceDialog', true);
                        return;
                    }
                    
                    // 其他类型走原来的撤销逻辑
                    ApproveService.undo({type: type,action_type:this.$route.query['type'], order_id: this.id, revise_id: this.$route.query['revise_id']}).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: '撤销成功',
                                type: 'success'
                            });
                            
                            if(this.$route.query['type'] == this.params.TYPE_CLOSE) this.to_approve();
                            this.dialogVisibleBusiness = false;
                            this.is_show_edit = true;
                            this.hidden_undo = true;
                            this.getOrder(this.id);
                        }
                    })
                })
            },
            //是否可以进行撤销操作
            canUndo(type){
                if(this.order.user){
                    this.is_mine = this.order.user.find(item=>{
                        return item.user_id == this.$store.getters.userId && item.is_cooperator == 0;
                    })
                }

                // 补充订单审核撤销判断 - 根据type参数判断是否为补充订单
                if(this.$route.query['type'] == this.params.FILL_INVOICE) {
                    // 检查是否有update-fill接口权限
                    if(!this.Acs('/order/update-fill')) return false;
                    // 判断当前用户是否是补充订单的创建者
                    this.is_mine_supplement = this.order.finance.user_id == this.$store.getters.userId;
                    if (!this.is_mine_supplement) return false;
                    // 判断补充订单是否处于可撤销状态（是否已经被使用）
                    if(this.order.is_used != 0) return false;
                    //判断补充订单流程是否存在，不存在返回false
                     if(this.order.is_cancle == 0) return false;

                    return true;
                }

                if(this.$route.query['revise_id']>0){ //修订订单，允许进行撤销操作
                    this.is_mine_revise = this.order.user_id == this.$store.getters.userId;
                    if (!this.is_mine_revise) return false;
                    if (type == this.params.PRODUCT_LINE) {
                        if(!this.order.order_detail.revise_product) return false;
                    } else if (type == this.params.FINANCE_LINE) {
                        if(!this.order.order_detail.revise_finance) return false;
                    } else if (type == this.params.CONTRACT_LINE) {
                        if(!this.order.order_detail.revise_contract) return false;
                    }
                    return true;
                }
                //如果流程线发起人是当前用户就可以进行撤销操作
                if(this.progresses){
                    let process = this.progresses.find(item=>{
                        return item.flow_type==type && item.send_user_id==this.$store.getters.userId;
                    })
                    if(process){
                        return this.checkOrderStatus(type)
                    }
                }
                if (!this.is_mine) return false;
                return this.checkOrderStatus(type);

            },
            checkOrderStatus(type){
                if (type == this.params.PRODUCT_LINE) {
                    if(this.order.undo_product) return false;
                    if(this.order.business_audit == this.params.TYPE_NO_CHECKED)return true;
                } else if (type == this.params.FINANCE_LINE) {
                    if(this.order.close_audit == this.params.TYPE_NO_CHECKED && this.$route.query['type'] == this.params.TYPE_CLOSE
                        && this.order.close_flow_type == type && this.order.close_exec==this.$store.getters.name){
                        return true;
                    }
                    if(this.order.undo_finance) return false;
                    if(this.order.revise_finance) return false;
                    if(this.order.finance_audit == this.params.TYPE_NO_CHECKED) return true;
                } else if (type == this.params.CONTRACT_LINE) {
                    if(this.order.close_audit == this.params.TYPE_NO_CHECKED && this.$route.query['type'] == this.params.TYPE_CLOSE
                        && this.order.close_flow_type == type && this.order.close_exec==this.$store.getters.name){
                        return true;
                    }
                    if(this.order.undo_contract) return false;
                    if(this.order.revise_contract) return false;
                    if(this.order.contract_audit == this.params.TYPE_NO_CHECKED)return true;
                }
                if(this.$route.query['type'] == this.params.TYPE_CLOSE){
                    if(this.order.close_audit == this.params.TYPE_NO_CHECKED)return true;
                }
                return false;
            },
            //是否可以进行编辑操作
            canEdit(type){
                if (this.order.close_audit) {
                    return false;
                }

                // if(!this.is_mine){
                //     return false;
                // }

                if (type == this.params.PRODUCT_LINE) {
                    if(this.order.business_audit==Params.TYPE_CHECKED_INIT && this.order.undo_product) return true;
                    if(this.order.business_audit == Params.TYPE_CHECKED_FAIL) return true;
                    return this.order.undo_product && this.order.business_audit == Params.TYPE_CHECKED;
                }
                if (type == this.params.FINANCE_LINE) {
                    if(this.order.finance_audit==Params.TYPE_CHECKED_INIT && this.order.undo_finance) return true;
                    if(this.order.finance_audit == Params.TYPE_CHECKED_FAIL && !this.order.revise_finance ) return true;
                    return this.order.undo_finance && this.order.finance_audit == Params.TYPE_CHECKED;
                }
                if (type == this.params.CONTRACT_LINE) {
                    if(this.order.contract_audit==Params.TYPE_CHECKED_INIT && this.order.undo_contract) return true;
                    if(this.order.contract_audit == Params.TYPE_CHECKED_FAIL  && !this.order.revise_contract) return true;
                    return this.order.undo_contract && this.order.contract_audit == Params.TYPE_CHECKED;
                }
            },
            //是否可以进行审核操作
            canCheck(type) {
                if(!this.$route.query['flow_type']){
                    return false;
                }
                if (this.order.close_audit == Params.TYPE_CHECKED) {
                    return false;
                }
                if(this.is_checked){
                    return false;
                }
                if(this.$route.query['type']==2){ //关闭审核 不需要判断是否撤销
                    return this.is_mine_check;
                }
                if (type == this.params.PRODUCT_LINE) {
                    return  !this.order.undo_product && this.is_mine_check;
                }
                if (type == this.params.FINANCE_LINE) {
                    return  !this.order.undo_finance && this.is_mine_check;
                }
                if (type == this.params.CONTRACT_LINE) {
                    return  !this.order.undo_contract && this.is_mine_check;
                }
            },
            getPro() {
                let type = this.$route.query['type'] ? this.$route.query['type'] : 1;
                let revise_id = this.$route.query['revise_id']?this.$route.query['revise_id']:0;
                let t = new Date().getTime();
                let pred = cache[this.id] &&  t - cache[this.id].time > 2000;
                pred = pred || ! cache[this.id];

                if(this.order && this.order.revise_finance_id && this.tab==this.params.FINANCE_LINE){
                    this.tips_check = "修订审核";
                    type = this.params.TYPE_REVISE;
                    revise_id = this.order.revise_finance_id;
                }
                if(this.order && this.order.revise_contract_id && this.tab==this.params.CONTRACT_LINE){
                    this.tips_check = "修订审核";
                    type = this.params.TYPE_REVISE;
                    revise_id = this.order.revise_contract_id;
                }
                if(this.order && this.order.close_audit){ //合同关闭
                    let show = false;
                    if(this.order.contract_audit==1 && this.order.finance_audit==1 && this.tab==3){
                        show = true;
                    }else if((this.order.finance_audit==1 && this.order.contract_audit ==0 && this.tab==3)){
                        show = true;
                    }else if((this.order.finance_audit==1 && this.order.contract_audit ==2 && this.tab==2)){
                        show = true;
                    }else if(this.order.finance_audit==0){
                        show = true;
                    }else if(this.order.undo_finance && this.order.finance_audit==3){
                        show = true;
                    }
                    if(show){
                        this.tips_check = "关闭审核";
                        type =this.params.TYPE_CLOSE;
                        revise_id = 0;
                    }
                }
                //if (pred) {
                cache[this.id] = {　data: OrderService.getProgress(this.id, type,revise_id), time: t };
                //}
                cache[this.id].data.then(res => {
                    let progresses = _.groupBy(res.data, 'flow_type');
                    if (progresses[this.tab]) { //步骤图
                        progresses[this.tab].forEach((item, index) => {
                            let last = _.last(progresses[this.tab]);
                            item.is_last = false;
                            if (item.status == Params.TYPE_CHECKED) {
                                if (item.id == last.id) { //说明是最后一个审核，而且审核已通过
                                    item.is_last = true;
                                    this.check_progress = index + 2;
                                } else {
                                    this.check_progress = index + 1;
                                }
                            }
                            if (item.id == last.id) {
                                item.is_last = true;
                            }
                            if (item.flow_node_executor_id == this.$store.getters.userId
                                && (item.status == Params.TYPE_CHECKED || item.status == Params.TYPE_CHECKED_FAIL)) {
                                this.is_checked = true;
                            }
                            if (item.flow_node_executor_id == this.$store.getters.userId && item.status == Params.TYPE_NO_CHECKED) {
                                this.is_mine_check = true;
                                // 保存当前流程节点的编辑时间
                                this.checkForm.edit_time = item.updated_at || '';
                            }
                        })
                    }

                    this.progresses = progresses[this.tab];
                });

            },


            getReasons(type) {
                if (type) {
                    if (type == 2) {
                        this.reasons = Params.getFinanceReasons();
                    }

                    if (type == 3) {
                        this.reasons = Params.getContractReasons();
                    }
                }

                return this.reasons;
            },
        }

    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_line.vue